import { Pressable, Text, View } from 'react-native'

import { convertLineHeight, convertPercentageToNumber, styled } from '~/utils'

export const Root = styled(Pressable, theme => {
  return {
    base: {
      paddingHorizontal: theme.paddingInsetFourpulse,
      paddingTop: theme.paddingInsetFourpulse,
      paddingBottom: theme.paddingInsetFourpulse,
      flexDirection: 'row',
      gap: theme.spacingInlineTwopulse,
      alignItems: 'center',
    },
    variants: {
      hasFooter: {
        true: {
          paddingBottom: theme.paddingInsetNone,
        },
      },
    },
  }
})

export const IconArea = styled(View, theme => {
  return {
    base: {
      maxHeight: theme.sizingHuge,
    },
    variants: {},
  }
})

export const TitleAndDescriptionBox = styled(View, theme => {
  return {
    base: {
      gap: theme.spacingStackOnepulse,
      backgroundColor: 'transparent',
      maxHeight: theme.sizingHuge,
    },
    variants: {
      full: {
        true: {
          flex: 1,
        },
      },
    },
  }
})

export const Title = styled(Text, theme => {
  return {
    base: {
      color: theme.colorTextNeutralDefault,
      fontFamily: theme.fontFamily.bold,
      fontSize: theme.fontSizeThreeandhalfpulse,
      lineHeight: convertLineHeight(
        theme.fontSizeThreeandhalfpulse,
        theme.lineHeightSmall
      ),
      letterSpacing: convertPercentageToNumber(theme.letterSpacingDefault),
    },
    variants: {},
  }
})

export const Description = styled(Text, theme => {
  return {
    base: {
      color: theme.colorTextNeutralDefault,
      fontFamily: theme.fontFamily.regular,
      fontSize: theme.fontSizeThreeandhalfpulse,
      lineHeight: convertLineHeight(
        theme.fontSizeThreeandhalfpulse,
        theme.lineHeightSmall
      ),
      letterSpacing: convertPercentageToNumber(theme.letterSpacingDefault),
    },
    variants: {},
  }
})
